/**
 * SCROLL TO HASH
 * Read and the hash in the URL, strip it, reset the scroll,
 * then smooth scroll to the element.
 *
 * Should run as early as possible for best performance.
 */
if (window.location.hash) {
    let hash = location.hash.substr(1);
    window.originalHash = hash;
    setTimeout(function() {
        history.replaceState("", document.title, window.location.pathname + window.location.search);
        window.scrollTo(0, 0);
    }, 1);

    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
            let element = document.getElementById(hash);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: "start",
                })
            }
        }, 1000);
    });
}
